import { useAppDispatch } from '@/shared/model';
import { setNotification } from '@/shared/model/appSlice';

export const useNotification = () => {
  const dispatch = useAppDispatch();
  return ({
    value,
    variant,
  }: {
    value: string;
    variant: 'success' | 'error';
  }) => {
    dispatch(setNotification({ value, variant }));
  };
};
